'use es6';

import http from 'hub-http/clients/apiClient';
import formatFeedbackForms from 'reference-resolvers/formatters/formatFeedbackForms';
export const createGetAllFeedbackForms = ({
  httpClient
}) => () => httpClient.get('feedback/v1/survey-config').then(formatFeedbackForms);
export const getAllFeedbackForms = createGetAllFeedbackForms({
  httpClient: http
});